// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/propeller-aerodynamics.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/propeller-aerodynamics/propeller-aerodynamics.js';

mount([g0]);
